(() => {
  'use strict';
  if (customElements.get('dw-product-bundles')) return;
  const root = window.Shopify?.routes?.root || '/';
  let sequence = 0;
  const make = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text != null) el.textContent = text; return el; };
  async function request(url, options) {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'Unable to update your cart. Please try again.');
    return data;
  }
  class ProductBundles extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-bundle-data]');
      this.form = this.closest('form');
      if (!data || !this.form) return;
      this.data = JSON.parse(data.textContent);
      const products = this.querySelector('[data-bundle-products]');
      const mixedProducts = products ? JSON.parse(products.textContent) : [];
      const sameEnabled = this.dataset.sameEnabled !== 'false';
      const mixedEnabled = mixedProducts.length > 1;
      // Legacy markup without mode controls retains its previous behavior.
      if (!this.mode) this.mode = mixedEnabled ? 'mixed' : 'same';
      this.mixed = this.mode === 'mixed' && mixedEnabled;
      this.products = this.mixed ? mixedProducts : [this.data];
      this.querySelector('.dw-bundle-types')?.remove();
      if (sameEnabled && mixedEnabled) {
        const types = make('div','dw-bundle-types'); types.setAttribute('role','group'); types.setAttribute('aria-label','Bundle type');
        for (const [mode,label] of [['mixed','Mixed Product Pack'],['same','Same Product Pack']]) {
          const button = make('button','dw-bundle-type',label); button.type = 'button';
          button.dataset.bundleMode = mode; button.setAttribute('aria-pressed',String(this.mode === mode));
          button.addEventListener('click',() => {
            if (this.busy || this.mode === mode) return;
            this.mode = mode; this.ready = false;
            this.querySelector('[data-bundle-packs]').replaceChildren();
            this.connectedCallback(); this.setError('');
            this.querySelector('[data-bundle-status]').textContent = '';
            this.querySelector(`[data-bundle-mode="${mode}"]`).focus({preventScroll:true});
          });
          types.append(button);
        }
        this.querySelector('[data-bundle-packs]').before(types);
      }
      this.count = 1; this.packRows = {}; this.cartCounts = {}; this.busy = false;
      this.uid = 'dw-bundle-' + (++sequence);
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:this.data.currency || 'INR'}).format(cents / 100);
      this.error = this.querySelector('[data-bundle-error]');
      const initialId = new FormData(this.form).get('id');
      this.initial = this.data.variants.find(v => String(v.id) === String(initialId)) || this.data.variants.find(v => v.available) || this.data.variants[0];
      if (!this.initial) return;
      const host = this.querySelector('[data-bundle-packs]');
      for (let count = 1; count <= 3; count++) {
        const panel = make('div','dw-bundle-pack'); panel.dataset.pack = count;
        const head = make('label','dw-bundle-choice');
        const radio = make('input'); radio.type = 'radio'; radio.name = this.uid; radio.value = count; radio.checked = count === 1;
        radio.setAttribute('aria-controls',this.uid + '-rows-' + count);
        const heading = make('span','dw-bundle-name','Pack of ' + count);
        const price = make('span','dw-bundle-price');
        head.append(radio,heading,price);
        const summary = make('p','dw-bundle-summary');
        const rows = make('div','dw-bundle-rows'); rows.id = this.uid + '-rows-' + count;
        this.packRows[count] = [];
        const rowCount = this.mixed && count === 2 ? this.products.length : count;
        for (let index = 0; index < rowCount; index++) {
          const row = make('div','dw-bundle-row');
          const img = make('img'); img.width = 38; img.height = 50; img.alt = ''; img.loading = 'lazy';
          row.append(img,make('span','dw-bundle-item-number',String(index + 1)));
          const product = this.mixed ? this.products[index % this.products.length] : this.data;
          const initial = index === 0 ? this.initial : product.variants.find(v => v.available) || product.variants[0];
          const entry = {row,img,product,values:initial.options.slice(),selects:[],manualSize:false};
          if (this.mixed) {
            const title = make('div','dw-bundle-product');
            title.append(make('span','','Product'));
            if (count === 2 && index > 0) {
              const choice = make('label','dw-bundle-companion-title');
              const picker = make('input'); picker.type = 'radio'; picker.name = this.uid + '-companion'; picker.value = product.id;
              picker.checked = index === 1; entry.picker = picker;
              picker.addEventListener('change',event => { event.stopPropagation(); this.setError(''); this.update(); });
              choice.append(picker,make('strong','',this.cleanTitle(product.title))); title.append(choice);
            } else title.append(make('strong','',this.cleanTitle(product.title)));
            row.prepend(title);
          }
          this.buildOptions(entry,count,index);
          entry.error = make('p','dw-bundle-row-error'); entry.error.id = this.uid + '-error-' + count + '-' + index; entry.error.setAttribute('role','status');
          entry.selects.forEach(({select}) => select.setAttribute('aria-describedby',entry.error.id));
          row.append(entry.error); rows.append(row); this.packRows[count].push(entry);
        }
        this.syncSizes(count);
        panel.append(head,summary,rows); host.append(panel);
        radio.addEventListener('change',event => { event.stopPropagation(); this.count = count; this.setError(''); this.update(); });
      }
      this.ready = true; this.hidden = false; this.form.classList.add('dw-bundle-form'); this.update();
    }
    cleanTitle(title) { return (title || '').replace(/^dermawear\s+(?:(?:men(?:'s)?|women(?:'s)?)\s+)?/i,''); }
    sizeIndex(product) { return product.options.findIndex(option => /^size$/i.test(option.name)); }
    buildOptions(entry,count,index) {
      entry.selects.forEach(({select}) => select.closest('label').remove()); entry.selects = [];
      entry.product.options.forEach((option,optionIndex) => {
        if (option.name === 'Title' && option.values.length === 1) return;
        const label = make('label','dw-bundle-option'); label.append(make('span','',option.name));
        const select = make('select'); select.setAttribute('aria-label',`Pack of ${count}, item ${index+1}, ${option.name}`);
        option.values.forEach(value => { const text = typeof value === 'string' ? value : value.name; const opt = make('option','',text); opt.value = text; select.append(opt); });
        select.value = entry.values[optionIndex];
        select.addEventListener('change',event => {
          event.stopPropagation(); entry.values[optionIndex] = select.value;
          if (optionIndex === this.sizeIndex(entry.product)) {
            if (index === 0) this.syncSizes(count); else entry.manualSize = true;
          }
          this.setError(''); this.update();
        });
        if (entry.error) select.setAttribute('aria-describedby',entry.error.id);
        label.append(select); entry.row.insertBefore(label,entry.error || null); entry.selects.push({select,optionIndex});
      });
    }
    syncSizes(count) {
      if (!this.mixed) return;
      const entries = this.packRows[count], first = entries[0];
      if (!first) return;
      const size = first.values[this.sizeIndex(first.product)];
      if (!size) return;
      entries.slice(1).forEach(entry => {
        const index = this.sizeIndex(entry.product);
        if (index < 0 || entry.manualSize) return;
        entry.values[index] = size;
        const select = entry.selects.find(item => item.optionIndex === index)?.select;
        if (select) {
          if (!Array.from(select.options).some(option => option.value === size)) {
            const opt = make('option','',size + ' � Unavailable'); opt.value = size; select.append(opt);
          }
          select.value = size;
        }
      });
    }
    selectedEntries(count = this.count) { return this.packRows[count].filter(entry => !entry.picker || entry.picker.checked); }
    variant(entry) { return entry.product.variants.find(v => v.options.every((value,index) => value === entry.values[index])); }
    setError(message) { this.error.textContent = message; this.error.hidden = !message; }
    update() {
      this.dataset.packCount = this.count;
      this.querySelectorAll('.dw-bundle-type').forEach(button => button.disabled = this.busy);
      const totalStock = this.products.flatMap(product => product.variants).reduce((sum,v) => !v.available ? sum : sum + (v.limit == null ? 999999 : Math.max(0,v.limit - (this.cartCounts[v.id] || 0))),0);
      for (let count = 1; count <= 3; count++) {
        const panel = this.querySelector(`[data-pack="${count}"]`), active = count === this.count;
        panel.classList.toggle('is-active',active); panel.classList.toggle('is-unavailable',totalStock < count || (this.mixed && count > this.products.length));
        const radio = panel.querySelector('input[type="radio"]'); radio.disabled = totalStock < count || (this.mixed && count > this.products.length) || this.busy; radio.setAttribute('aria-expanded',String(active));
        panel.querySelector('.dw-bundle-rows').hidden = !active;
        let subtotal = 0;
        const quantities = {};
        this.selectedEntries(count).forEach(entry => { const v = this.variant(entry); if (v) quantities[v.id] = (quantities[v.id] || 0) + 1; });
        this.packRows[count].forEach(entry => {
          const v = this.variant(entry); if (!entry.picker || entry.picker.checked) subtotal += v?.price || 0;
          const source = v?.image || entry.product.image; if (source) entry.img.src = source;
          let error = '';
          if (!v) error = 'This colour and size combination is not available.';
          else if ((v.min || 1) > 1 || (v.increment || 1) > 1) error = 'This variant cannot be purchased as a single bundle item.';
          else if (!v.available) error = 'Sorry, this variant is out of stock. Please choose another option.';
          else if (v.limit != null && quantities[v.id] + (this.cartCounts[v.id] || 0) > v.limit) error = 'Not enough stock for this selection. Choose another variant or a smaller pack.';
          else if (v.max != null && quantities[v.id] + (this.cartCounts[v.id] || 0) > v.max) error = 'This selection exceeds the quantity limit.';
          entry.error.textContent = error; entry.error.hidden = !error;
          if (entry.picker) entry.picker.disabled = this.busy;
          entry.selects.forEach(({select,optionIndex}) => {
            select.disabled = this.busy; select.setAttribute('aria-invalid',String(Boolean(error)));
            Array.from(select.options).forEach(option => {
              const available = entry.product.variants.some(candidate => candidate.available && candidate.options.every((value,i) => value === (i === optionIndex ? option.value : entry.values[i])));
              option.textContent = option.value + (available ? '' : ' — Unavailable');
            });
          });
        });
        const discountTwo = this.mixed ? (this.dataset.mixedDiscountTwo ?? this.dataset.discountTwo) : this.dataset.discountTwo;
        const discountThree = this.mixed ? (this.dataset.mixedDiscountThree ?? this.dataset.discountThree) : this.dataset.discountThree;
        const discount = count === 2 ? Number(discountTwo) : count === 3 ? Number(discountThree) : 0;
        const total = Math.round(subtotal * (1 - Math.min(100,Math.max(0,discount || 0)) / 100));
        panel.querySelector('.dw-bundle-price').textContent = this.money(total) + ' total';
        panel.querySelector('.dw-bundle-summary').textContent = totalStock < count ? 'Not enough stock for this pack' : discount > 0 ? `${discount}% off · Save ${this.money(subtotal-total)} · Estimated total; discount applied at checkout` : `${this.money(count ? total/count : total)} per item · Standard price`;
      }
      const invalid = this.selectedEntries().some(entry => !entry.error.hidden);
      this.form.querySelectorAll('button[type="submit"]').forEach(button => {
        button.disabled = this.busy || invalid;
        button.classList.toggle('disabled',this.busy || invalid);
        button.textContent = this.busy ? 'Checking your pack…' : invalid ? 'Choose available options' : 'Add to cart';
      });
    }
    items() {
      this.update();
      const invalid = this.selectedEntries().find(entry => !entry.error.hidden);
      if (invalid) { this.setError(invalid.error.textContent); invalid.selects[0]?.select.focus(); throw new Error(invalid.error.textContent); }
      const grouped = new Map();
      for (const entry of this.selectedEntries()) { const v = this.variant(entry); grouped.set(v.id,(grouped.get(v.id)||0)+1); }
      const properties = {};
      for (const [name,value] of new FormData(this.form)) { const match = name.match(/^properties\[(.*)\]$/); if (match && typeof value === 'string' && value) properties[match[1]] = value; }
      return Array.from(grouped,([id,quantity]) => ({id,quantity,...(Object.keys(properties).length ? {properties} : {})}));
    }
    async prepare() {
      try {
        const selected = [...new Set(this.selectedEntries().map(entry => entry.product))];
        const [fresh,cart] = await Promise.all([
          Promise.all(selected.map(async product => {
            const url = new URL(product.url,location.origin); url.searchParams.set('section_id','dw-bundle-stock');
            const response = await fetch(url,{cache:'no-store'});
            if (!response.ok) throw new Error('Unable to check stock. Please try again.');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const data = doc.querySelector('[data-bundle-data]');
            if (!data) throw new Error('Unable to check stock. Please refresh the page.');
            return {product,data:JSON.parse(data.textContent)};
          })), request(root + 'cart.js',{cache:'no-store'})
        ]);
        fresh.forEach(({product,data}) => { product.variants = data.variants; });
        this.cartCounts = {};
        cart.items.forEach(item => { this.cartCounts[item.variant_id] = (this.cartCounts[item.variant_id] || 0) + item.quantity; });
        return this.items();
      } catch(error) { this.setError(error.message); throw error; }
    }
    async add(checkout = false) {
      if (this.busy) return;
      this.busy = true; this.setAttribute('aria-busy','true'); this.setError('');
      const status = this.querySelector('[data-bundle-status]'); status.textContent = 'Checking stock…'; this.update();
      try {
        const items = await this.prepare(); status.textContent = 'Adding your pack…';
        const response = await request(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:['side-cart'],sections_url:location.pathname})});
        status.textContent = 'Pack added to your cart.';
        if (window.ajaxCart && response.sections?.['side-cart']) window.ajaxCart.load(response,false);
        const cart = await request(root + 'cart.js').catch(() => null);
        if (cart) document.querySelectorAll('#cart-count').forEach(el => el.textContent = cart.item_count);
        if (checkout) {
          status.textContent = 'Pack added. Opening checkout…';
          if (typeof window.dwValidateGiftCheckout === 'function' && !await window.dwValidateGiftCheckout()) return;
          location.assign(root + 'checkout'); return;
        }
        if (window.DWShopping) window.DWShopping.afterAdd(response,this.data.id);
        else if (window.ajaxCart && response.sections?.['side-cart']) window.ajaxCart.load(response,true);
        else location.assign(root + 'cart');
      } catch(error) { this.setError(error.message); status.textContent = ''; }
      finally { this.busy = false; this.removeAttribute('aria-busy'); this.update(); }
    }
  }
  customElements.define('dw-product-bundles',ProductBundles);
  window.DWBundles = {prepare: async form => {
    const bundle = form?.querySelector('dw-product-bundles');
    if (!bundle?.ready) return null;
    if (bundle.busy) throw new Error('Please wait for your pack to finish updating.');
    bundle.busy = true; bundle.update();
    try { return await bundle.prepare(); } finally { bundle.busy = false; bundle.update(); }
  }};
  // Native unbranded Buy Now fallback when GoKwik has not claimed the button.
  document.addEventListener('click',event => {
    const button = event.target.closest('.shopify-payment-button__button--unbranded');
    if (!button || button.dataset.gokwikProcessed || button.dataset.gokwikFunction) return;
    const bundle = button.closest('form')?.querySelector('dw-product-bundles');
    if (!bundle?.ready) return;
    event.preventDefault(); event.stopImmediatePropagation(); bundle.add(true);
  },true);
  document.addEventListener('submit',event => {
    const bundle = event.target.querySelector?.('dw-product-bundles');
    if (!bundle?.ready) return;
    event.preventDefault(); event.stopImmediatePropagation(); bundle.add();
  },true);
})();